import { iTrack } from '../types/ITrack';

/** Crate row from API, agent tools, or recommendations — field names vary. */
export type CrateTrackLike = iTrack | Record<string, unknown>;

const asLoose = (track: CrateTrackLike): Record<string, unknown> =>
  track as Record<string, unknown>;

const readText = (value: unknown): string =>
  typeof value === 'string' ? value.trim() : '';

export const readArtistValue = (value: unknown): string => {
  if (typeof value === 'string') return value.trim();
  if (!value || typeof value !== 'object') return '';

  const name = (value as { name?: unknown }).name;
  if (typeof name === 'string' && name.trim()) return name.trim();

  if (Array.isArray(value)) {
    return value
      .map((entry) => readArtistValue(entry))
      .filter(Boolean)
      .join(', ');
  }

  return '';
};

export const readTrackTitle = (track: CrateTrackLike): string => {
  const row = asLoose(track);
  return (
    readText(row.Title) ||
    readText(row.title) ||
    readText(row.name) ||
    readText(row.Name)
  );
};

export const readTrackArtist = (track: CrateTrackLike): string => {
  const row = asLoose(track);
  return (
    readText(row.Artist) ||
    readText(row.artist) ||
    readArtistValue(row.artists) ||
    readArtistValue(row.Artist)
  );
};

/** Crates stored in Bubble carry the ISRC as `ISRC`; the app reads `isrc`. */
export const readTrackIsrc = (track: CrateTrackLike): string | undefined => {
  const row = asLoose(track);
  return readText(row.isrc) || readText(row.ISRC) || undefined;
};
